export default "__VITE_ASSET__E67jM6mq__"